import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAppSelector, useAppDispatch } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import { updatePendingRequestDetails } from '@app/store/slices/authSlice';

const usePendingRequestDetails = () => {
  const dispatch = useAppDispatch();
  const creditId = useAppSelector((state) => state.auth.userDetails?.linkedCredits[0]?.creditId);
  const pendingRequestDetails = useAppSelector((state) => state.auth.pendingRequestDetails);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPendingRequests = async () => {
    if (!creditId) return;
    
    setIsLoading(true);
    try {
      const url = endpoints.pendingRequests + creditId;
      const res = await axios.get(url);
      dispatch(updatePendingRequestDetails(res?.data ?? {}));
    } catch (err) {
      console.log('fetchPendingRequests', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (creditId && (!pendingRequestDetails || Object.keys(pendingRequestDetails).length === 0)) {
      fetchPendingRequests();
    }
  }, [creditId]);

  return {
    pendingRequestDetails,
    isLoading,
  };
};

export default usePendingRequestDetails;